import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import m from '../messages';
import Pagination from '../../common/pagination';
import UserLink from '../../common/user-link';
import { convertToDate } from '../../utils';
import NotiveEmpty from '../notice-empty';


export default function TableThread({ threads, messages, items, paging }) {
  const hasItems = !!items.length;

  const renderTableHead = () => (
    <div className='table__row table__row--header'>
      <div className='table__col'>Thread</div>
      <div className='table__col'>Author</div>
      <div className='table__col'>Replies</div>
      <div className='table__col'>Last Post</div>
    </div>
  )


  const renderTableBody = () => items.map(rowItem => (
    <div className='table__row' key={rowItem.id}>
      <div className='table__col'>
        <Link className='table__link' to={`/${rowItem.path}/${rowItem.id}`}>
          {rowItem.subject}
        </Link>
      </div>
      <div className='table__col'>
        <UserLink userData={rowItem.user} />
      </div>
      <div className='table__col'>{rowItem.repliesCount}</div>
      <div className='table__col'>{rowItem.lastPost && convertToDate(rowItem.lastPost)}</div>
    </div>
  ))


    const renderBodyTitle = () => (
      <div className='table__meta-info'>
        <span className='table__meta-data'>
          <FormattedMessage {...m.threads} />: {threads}
        </span>
        {' - '}
        <span className='table__meta-data'>
          <FormattedMessage {...m.messages} />: {messages}
        </span>
      </div>
    )

    const renderBodyContent = () => (
      <>
        { renderTableHead() }
        { renderTableBody() }
        { paging && <Pagination hasItems={hasItems} paging={paging} countType='hundred' />}
      </>
    )

  return (
    <div className='table table--thread'>
      <div className='table__body'>
        { (Array.isArray(items) && items.length)
          ? (
              <>
                { renderBodyTitle() }
                { renderBodyContent() }
              </>
            )
          : <NotiveEmpty board />
        }
      </div>

    </div>
  )
}

TableThread.propTypes = {
  threads: PropTypes.number,
  messages: PropTypes.number,
  tools: PropTypes.object,
  items: PropTypes.array,
  paging: PropTypes.object
}

